<template>
  <div class="container page">
    <!-- 顶部导航栏 -->
    <van-nav-bar :title="$t('setting.modify_real_name')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
     <!-- <template #right>
        <span class="nav-right" @click="save()">{{$t("setting.save")}}</span>
      </template> -->
    </van-nav-bar>

    <!-- 表单区域 -->
    <div class="form-wrapper">
      <div class="form-card">
        <van-field
          v-model="name"
          :readonly="userInfo.name !== ''"
          :label="$t('setting.name')"
          :placeholder="$t('setting.name_place')"
          class="name-field"
        />
      </div>

      <!-- 提示信息 -->
      <div class="tip-box">
        <van-icon name="info-o" color="#ff9800" size="18PX" />
        <span class="tip-text">{{$t("setting.name_tip")}}</span>
      </div>

      <!-- 保存按钮 -->
      <van-button 
        class="save-btn" 
        block 
        color="linear-gradient(90deg, #ff5f6d, #ff2d55)" 
        @click="save()"
      >
        {{$t("setting.save")}}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      userInfo: {}
    };
  },
  methods: {
    back() {
      this.$router.push({path: '/Mine'});
    },
    save() {
      if (this.userInfo.name) {
        this.$toast(this.$t("setting.repect"));
        return true;
      }
      if (this.name === "" || this.name === null || this.name === undefined) {
        this.$toast.fail(this.$t("setting.name_place"));
        return false;
      }
      this.$http({
        method: 'get',
        data: {name: this.name},
        url: 'user_set_name'
      }).then(res => {
        if (res.code === 200) {
          this.getUserInfo();
          this.name = this.userInfo.name;
          this.$toast(res.msg);
          this.$router.push({path: '/Mine'});
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'});
    } else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
.page {
  min-height: 100VH;
  background: #f7f8fa;
}

/* 顶部导航栏 */
.nav-bar {
  background: #8600ff;
  :deep(.van-nav-bar__title) {
    color: #333;
    font-size: 18PX;
    font-weight: 600;
  }
  :deep(.van-icon) {
    color: #333;
  }
}

.nav-right {
  font-size: 15PX;
  color: #333;
  font-weight: 500;
}

/* 表单区域 */
.form-wrapper {
  padding: 20PX 15PX;
}

/* 表单卡片 */
.form-card {
  background: #fff;
  border-radius: 12PX;
  padding: 5PX 15PX;
  box-shadow: 0 4PX 12PX rgba(0, 0, 0, 0.05);
  margin-bottom: 15PX;
}

.name-field {
  :deep(.van-field__label) {
    font-size: 15PX;
    color: #333;
    font-weight: 500;
  }
  :deep(.van-field__control) {
    font-size: 15PX;
    color: #333;
  }
  :deep(.van-field__control::placeholder) {
    color: #999;
  }
}

/* 提示信息 */
.tip-box {
  display: flex;
  align-items: flex-start;
  gap: 8PX;
  background: #fff7e6;
  border-radius: 8PX;
  padding: 12PX 15PX;
  margin-bottom: 30PX;
}

.tip-text {
  font-size: 13PX;
  color: #ff9800;
  line-height: 20PX;
  flex: 1;
}

/* 保存按钮 */
.save-btn {
  height: 50PX;
  border-radius: 25PX;
  font-size: 16PX;
  font-weight: 600;
  color: #fff;
  border: none;
}

.save-btn::after {
  border: none;
}
::v-deep .van-cell{
	font-size: 14PX;line-height: 32PX;
}
::v-deep .van-field__control {
  font-size: 14PX;line-height: 32PX;
  color: #333;
}

/* 修改 placeholder 字体大小 */
::v-deep  .van-field__control::placeholder {
  font-size: 14PX;line-height: 32PX;
  color: #999;
}
</style>